import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import { authorizeNew } from '../apis/authorization/authorizeNew';
import { authorizeWithSecret } from '../apis/authorization/authorizeWithSecret';
import { refreshAuthorization } from '../apis/authorization/refreshAuthorization';
import { ProjectJwtPayload } from '../apis/projects/ProjectJwtPayload';

type AuthStatus = 'pending' | 'error' | 'ready';

export const { actions, reducer } = createSlice({

    name: 'auth',

    initialState: {

        authStatus: 'ready' as AuthStatus,

        id: null as string | null,
        jwt: null as string | null,
        secret: null as string | null
    },

    reducers: {
        updateFromJwt: (state, action: PayloadAction<string>) => ({
            ...state,
            ...decodeJwt(action.payload),
            jwt: action.payload
        })
    },

    extraReducers: builder => {

        for (const authorizer of [authorizeNew, authorizeWithSecret, refreshAuthorization]) {
            builder
                .addCase(authorizer.pending, state => void (state.authStatus = 'pending'))
                .addCase(authorizer.rejected, state => void (state.authStatus = 'error'))
                .addCase(authorizer.fulfilled, (state, action) => ({
                    ...state,
                    ...decodeJwt(action.payload.jwt),
                    jwt: action.payload.jwt,
                    secret: action.payload.secret ?? null,
                    authStatus: 'ready'
                }));
        }
    }
});

const decodeJwt = (jwt: string) => {
    const payload = jwtDecode<ProjectJwtPayload>(jwt);
    return {
        id: payload.project_id
    };
};